export default __webpack_public_path__ + "static/media/vip-icon-active.1c4041e7.webp";